const ExpenseTypeConstants = {
    MILEAGE: 0
}

export default ExpenseTypeConstants